/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Hesap_Nasil_AcilirInputs */

const tr_faq_q_hesap_nasil_acilir = /** @type {(inputs: Faq_Q_Hesap_Nasil_AcilirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel hesabı nasıl açılır?`)
};

const en_faq_q_hesap_nasil_acilir = /** @type {(inputs: Faq_Q_Hesap_Nasil_AcilirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I create a ShopPanel account?`)
};

const de_faq_q_hesap_nasil_acilir = /** @type {(inputs: Faq_Q_Hesap_Nasil_AcilirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie erstelle ich einen ShopPanel-Account?`)
};

const ru_faq_q_hesap_nasil_acilir = /** @type {(inputs: Faq_Q_Hesap_Nasil_AcilirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как создать аккаунт в ShopPanel?`)
};

/**
* | output |
* | --- |
* | "How do I create a ShopPanel account?" |
*
* @param {Faq_Q_Hesap_Nasil_AcilirInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_hesap_nasil_acilir = /** @type {((inputs?: Faq_Q_Hesap_Nasil_AcilirInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Hesap_Nasil_AcilirInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_hesap_nasil_acilir(inputs)
	if (locale === "de") return de_faq_q_hesap_nasil_acilir(inputs)
	if (locale === "ru") return ru_faq_q_hesap_nasil_acilir(inputs)
	return tr_faq_q_hesap_nasil_acilir(inputs)
});